module.exports = __webpack_public_path__ + "img/jupyter-logo.df044938.png";